export default __webpack_public_path__ + "fonts/three-dot-icon.svg";